/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ControlByWebStatus from './ControlByWebStatus';
import HydroSystemStatusExternals from './HydroSystemStatusExternals';
import SystemStatus from './SystemStatus';

/**
 * The HydroSystemStatus model module.
 * @module model/HydroSystemStatus
 * @version 1.1.0
 */
class HydroSystemStatus {
    /**
     * Constructs a new <code>HydroSystemStatus</code>.
     * The status of the overall system sent by the Fire Controller
     * @alias module:model/HydroSystemStatus
     * @param controlByWebStatus {module:model/ControlByWebStatus} 
     * @param externals {module:model/HydroSystemStatusExternals} 
     * @param systemMessage {String} 
     * @param systemStatus {module:model/SystemStatus} 
     * @param timeSystemStatusLastUpdate {Date} The time the FireController state last changed
     * @param systemId {String} Unique Fire Controller Id of the  system
     * @param systemStatusDuration {String} Duration in ISO-8601 format
     */
    constructor(controlByWebStatus, externals, systemMessage, systemStatus, timeSystemStatusLastUpdate, systemId, systemStatusDuration) { 
        
        HydroSystemStatus.initialize(this, controlByWebStatus, externals, systemMessage, systemStatus, timeSystemStatusLastUpdate, systemId, systemStatusDuration);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, controlByWebStatus, externals, systemMessage, systemStatus, timeSystemStatusLastUpdate, systemId, systemStatusDuration) { 
        obj['controlByWebStatus'] = controlByWebStatus;
        obj['externals'] = externals;
        obj['systemMessage'] = systemMessage;
        obj['systemStatus'] = systemStatus;
        obj['timeSystemStatusLastUpdate'] = timeSystemStatusLastUpdate;
        obj['systemId'] = systemId;
        obj['systemStatusDuration'] = systemStatusDuration;
    }

    /**
     * Constructs a <code>HydroSystemStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/HydroSystemStatus} obj Optional instance to populate.
     * @return {module:model/HydroSystemStatus} The populated <code>HydroSystemStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new HydroSystemStatus();

            if (data.hasOwnProperty('controlByWebStatus')) {
                obj['controlByWebStatus'] = ControlByWebStatus.constructFromObject(data['controlByWebStatus']);
            }
            if (data.hasOwnProperty('externals')) {
                obj['externals'] = HydroSystemStatusExternals.constructFromObject(data['externals']);
            }
            if (data.hasOwnProperty('systemMessage')) {
                obj['systemMessage'] = ApiClient.convertToType(data['systemMessage'], 'String');
            }
            if (data.hasOwnProperty('systemStatus')) {
                obj['systemStatus'] = SystemStatus.constructFromObject(data['systemStatus']);
            }
            if (data.hasOwnProperty('timeSystemStatusLastUpdate')) {
                obj['timeSystemStatusLastUpdate'] = ApiClient.convertToType(data['timeSystemStatusLastUpdate'], 'Date');
            }
            if (data.hasOwnProperty('systemId')) {
                obj['systemId'] = ApiClient.convertToType(data['systemId'], 'String');
            }
            if (data.hasOwnProperty('systemStatusDuration')) {
                obj['systemStatusDuration'] = ApiClient.convertToType(data['systemStatusDuration'], 'String');
            }
            if (data.hasOwnProperty('timeReported')) {
                obj['timeReported'] = ApiClient.convertToType(data['timeReported'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>HydroSystemStatus</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>HydroSystemStatus</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of HydroSystemStatus.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // validate the optional field `controlByWebStatus`
        if (data['controlByWebStatus']) { // data not null
          ControlByWebStatus.validateJSON(data['controlByWebStatus']);
        }
        // validate the optional field `externals`
        if (data['externals']) { // data not null
          HydroSystemStatusExternals.validateJSON(data['externals']);
        }
        // ensure the json data is a string
        if (data['systemMessage'] && !(typeof data['systemMessage'] === 'string' || data['systemMessage'] instanceof String)) {
            throw new Error("Expected the field `systemMessage` to be a primitive type in the JSON string but got " + data['systemMessage']);
        }
        // validate the optional field `systemStatus`
        if (data['systemStatus']) { // data not null
          SystemStatus.validateJSON(data['systemStatus']);
        }
        // ensure the json data is a string
        if (data['systemId'] && !(typeof data['systemId'] === 'string' || data['systemId'] instanceof String)) {
            throw new Error("Expected the field `systemId` to be a primitive type in the JSON string but got " + data['systemId']);
        }
        // ensure the json data is a string
        if (data['systemStatusDuration'] && !(typeof data['systemStatusDuration'] === 'string' || data['systemStatusDuration'] instanceof String)) {
            throw new Error("Expected the field `systemStatusDuration` to be a primitive type in the JSON string but got " + data['systemStatusDuration']);
        }

        return true;
    }


}

HydroSystemStatus.RequiredProperties = ["controlByWebStatus", "externals", "systemMessage", "systemStatus", "timeSystemStatusLastUpdate", "systemId", "systemStatusDuration"];

/**
 * @member {module:model/ControlByWebStatus} controlByWebStatus
 */
HydroSystemStatus.prototype['controlByWebStatus'] = undefined;

/**
 * @member {module:model/HydroSystemStatusExternals} externals
 */
HydroSystemStatus.prototype['externals'] = undefined;

/**
 * @member {String} systemMessage
 */
HydroSystemStatus.prototype['systemMessage'] = undefined;

/**
 * @member {module:model/SystemStatus} systemStatus
 */
HydroSystemStatus.prototype['systemStatus'] = undefined;

/**
 * The time the FireController state last changed
 * @member {Date} timeSystemStatusLastUpdate
 */
HydroSystemStatus.prototype['timeSystemStatusLastUpdate'] = undefined;

/**
 * Unique Fire Controller Id of the  system
 * @member {String} systemId
 */
HydroSystemStatus.prototype['systemId'] = undefined;

/**
 * Duration in ISO-8601 format
 * @member {String} systemStatusDuration
 */
HydroSystemStatus.prototype['systemStatusDuration'] = undefined;

/**
 * The time the FireController is pushing the message out
 * @member {Date} timeReported
 */
HydroSystemStatus.prototype['timeReported'] = undefined;






export default HydroSystemStatus;

